import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  id: "pallet-small",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.03516 14.8493V13.3327H14.9685V14.8493H13.1685V14.316H8.90182V14.8493H7.10182V14.316H2.83516V14.8493H1.03516ZM3.83516 10.8327C3.64627 10.8327 3.48793 10.7688 3.36016 10.641C3.23238 10.5132 3.16849 10.3549 3.16849 10.166V1.83268C3.16849 1.64379 3.23238 1.48546 3.36016 1.35768C3.48793 1.2299 3.64627 1.16602 3.83516 1.16602H12.1685C12.3574 1.16602 12.5157 1.2299 12.6435 1.35768C12.7713 1.48546 12.8352 1.64379 12.8352 1.83268V10.3327C12.8352 10.4771 12.7879 10.5966 12.6935 10.691C12.599 10.7855 12.4796 10.8327 12.3352 10.8327H3.83516ZM4.16849 9.83268H11.8352V2.16602H4.16849V9.83268ZM5.88516 5.19935H10.1185V4.21602H5.88516V5.19935Z",
      fill: "#616161"
    }, null, -1)
  ])))
}
export default { render: render }